<template>
  <div class="selector-root">
    <!-- Trigger -->
    <div
      class="selector-trigger"
      @click="openDropdown"
    >
      <span
        v-if="selectedLabel"
        class="selector-trigger__value"
      >
        {{ selectedLabel }}
      </span>
      <span
        v-else
        class="selector-trigger__placeholder"
      >
        Selecciona un producto
      </span>

      <span class="selector-trigger__icon">
        ▾
      </span>
    </div>

    <!-- Modal flotante en body -->
    <teleport to="body">
      <div
        v-if="dropdownVisible"
        class="selector-modal-overlay"
        @click.self="closeDropdown"
      >
        <div class="selector-modal">
          <div class="selector-modal__header">
            <p class="selector-modal__title">
              Seleccionar producto
            </p>
            <button
              type="button"
              class="selector-modal__close"
              @click="closeDropdown"
            >
              ✕
            </button>
          </div>

          <div class="selector-modal__search">
            <input
              type="text"
              v-model="busqueda"
              placeholder="Buscar producto…"
              class="selector-modal__search-input"
            />
          </div>

          <ul class="selector-modal__list">
            <li
              v-for="prod in productosFiltrados"
              :key="prod.id_producto"
              class="selector-modal__item"
              @click="seleccionar(prod)"
            >
              <div class="selector-modal__item-main">
                <p class="selector-modal__item-name">
                  {{ prod.nombre }}
                </p>
                <p
                  v-if="prod.descripcion"
                  class="selector-modal__item-desc"
                >
                  {{ prod.descripcion }}
                </p>
              </div>

              <div class="selector-modal__item-meta">
                <span
                  v-if="prod.tipo_producto"
                  class="selector-modal__pill"
                >
                  {{ prod.tipo_producto }}
                </span>
              </div>
            </li>

            <li
              v-if="productosFiltrados.length === 0"
              class="selector-modal__empty"
            >
              Sin resultados…
            </li>
          </ul>
        </div>
      </div>
    </teleport>
  </div>
</template>

<script>
export default {
  name: 'SelectorProducto',
  props: {
    productos: {
      type: Array,
      default: () => [],
    },
    modelValue: [String, Number],
  },
  emits: ['update:modelValue', 'seleccionado'],
  data() {
    return {
      busqueda: '',
      dropdownVisible: false,
    };
  },
  computed: {
    productosFiltrados() {
      const lista = this.productos || [];
      const termino = (this.busqueda || '').toLowerCase().trim();

      if (!termino) return lista;

      return lista.filter((p) =>
        (p.nombre || '').toLowerCase().includes(termino)
      );
    },
    selectedLabel() {
      const lista = this.productos || [];
      const prod = lista.find((p) => p.id_producto === this.modelValue);
      return prod ? prod.nombre : '';
    },
  },
  methods: {
    openDropdown() {
      this.dropdownVisible = true;
    },
    closeDropdown() {
      this.dropdownVisible = false;
      this.busqueda = '';
    },
    seleccionar(prod) {
      this.$emit('update:modelValue', prod.id_producto);
      this.$emit('seleccionado', prod);
      this.closeDropdown();
    },
  },
};
</script>

<style scoped>
.selector-root {
  position: relative;
  width: 100%;
  min-width: 0;
}

/* Trigger "input" */
.selector-trigger {
  width: 100%;
  border-radius: 0.85rem;
  border: 1px solid rgba(148, 163, 184, 0.7);
  background: rgba(15, 23, 42, 0.92);
  color: #e5e7eb;
  padding: 0.45rem 0.75rem;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  gap: 0.5rem;
  transition:
    border-color 0.16s ease,
    box-shadow 0.16s ease,
    background 0.16s ease;
}

.selector-trigger__value {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.selector-trigger__placeholder {
  flex: 1;
  min-width: 0;
  font-size: 0.78rem;
  color: #9ca3af;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.selector-trigger__icon {
  font-size: 0.7rem;
  opacity: 0.8;
}

/* Overlay full-screen */
.selector-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: radial-gradient(
    circle at 0 0,
    rgba(148, 163, 184, 0.32),
    rgba(15, 23, 42, 0.96)
  );
  backdrop-filter: blur(16px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem 1rem;
}

/* Panel flotante */
.selector-modal {
  width: 100%;
  max-width: 520px;
  max-height: 80vh;
  border-radius: 1.4rem;
  border: 1px solid rgba(148, 163, 184, 0.7);
  background: radial-gradient(
      circle at 0 0,
      rgba(148, 163, 184, 0.38),
      rgba(15, 23, 42, 0.98)
    );
  box-shadow:
    0 24px 60px rgba(15, 23, 42, 0.95),
    0 0 0 1px rgba(15, 23, 42, 0.9);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Header */
.selector-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 0.9rem 0.5rem;
}

.selector-modal__title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #e5e7eb;
}

.selector-modal__close {
  border: none;
  background: transparent;
  color: #e5e7eb;
  font-size: 0.9rem;
  cursor: pointer;
}

/* Buscador */
.selector-modal__search {
  padding: 0.4rem 0.9rem 0.5rem;
  border-top: 1px solid rgba(148, 163, 184, 0.6);
  border-bottom: 1px solid rgba(148, 163, 184, 0.5);
  background: rgba(15, 23, 42, 0.98);
}

.selector-modal__search-input {
  width: 100%;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.75);
  background: rgba(15, 23, 42, 0.9);
  color: #e5e7eb;
  padding: 0.35rem 0.75rem;
  font-size: 0.78rem;
  outline: none;
}

.selector-modal__search-input::placeholder {
  color: #9ca3af;
}

/* Lista */
.selector-modal__list {
  flex: 1;
  overflow-y: auto;
  padding: 0.4rem 0.4rem 0.5rem;
}

/* Scroll fino */
.selector-modal__list::-webkit-scrollbar {
  width: 6px;
}
.selector-modal__list::-webkit-scrollbar-track {
  background: transparent;
}
.selector-modal__list::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.5);
  border-radius: 999px;
}

/* Items */
.selector-modal__item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.55rem;
  padding: 0.45rem 0.6rem;
  border-radius: 0.85rem;
  cursor: pointer;
  transition:
    background 0.12s ease,
    transform 0.06s ease;
}

.selector-modal__item:hover {
  background: rgba(30, 64, 175, 0.5);
}

.selector-modal__item-main {
  flex: 1;
  min-width: 0;
}

.selector-modal__item-name {
  font-size: 0.82rem;
  color: #e5e7eb;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.selector-modal__item-desc {
  font-size: 0.74rem;
  color: #9ca3af;
  margin-top: 0.08rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.selector-modal__item-meta {
  display: flex;
  align-items: center;
}

.selector-modal__pill {
  font-size: 0.7rem;
  padding: 0.1rem 0.45rem;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.8);
  background: rgba(15, 23, 42, 0.96);
  text-transform: capitalize;
  color: #e5e7eb;
}

.selector-modal__empty {
  padding: 0.4rem 0.6rem 0.5rem;
  font-size: 0.78rem;
  color: #9ca3af;
}
</style>
